import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { ConversationGridFiltersActions } from '../../../../../../sic-lib/reducers/conversationGridFiltersReducer';
import { ClientField } from '../../../../../../sic-lib/types/ClientField';
import { ConversationGridFiltersItem } from '../../../../../../sic-lib/types/ConversationGridFiltersItem';
import { hasDistinctFieldId } from '../../../../../../sic-lib/utils/functionalFilters';
import { mapToListOfFieldIds } from '../../../../../../sic-lib/utils/functionalMappers';

interface Props {
    anchorEl: HTMLElement | null;
    menuId: string;
    fields: ClientField[];
    filters: ConversationGridFiltersItem[];
    formDispatch: React.Dispatch<ConversationGridFiltersActions>;
    onCloseHandler: () => void;
}

export default function MenuAddFilterGroupRaw({
    anchorEl,
    menuId,
    fields,
    filters,
    formDispatch,
    onCloseHandler,
}: Props) {
    const sortFilter = (a: ClientField, b: ClientField) => {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        return 0;
    };

    const [options, setOptions] = React.useState<ClientField[]>([]);

    React.useEffect(() => {
        const nextOptions = fields.filter(hasDistinctFieldId(filters.map(mapToListOfFieldIds)));

        setOptions(nextOptions);
    }, [fields, filters]);

    const handleAddField = (event: React.MouseEvent<HTMLElement>) => {
        // console.log(event.currentTarget, event.currentTarget.dataset)
        const { fieldId } = event.currentTarget.dataset;

        if (fieldId) {
            formDispatch({
                type: 'ADD_FORM_FILTER',
                fieldId: +fieldId,
            });

            onCloseHandler();
        }
    };

    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            {options.sort(sortFilter).map(opt => (
                <MenuItem key={opt.fieldId} data-field-id={opt.fieldId} onClick={handleAddField}>
                    {opt.label}
                </MenuItem>
            ))}
        </Menu>
    );
}
